import { render, staticRenderFns } from "./adminLandingTermsTF.vue?vue&type=template&id=165857d2"
import script from "./adminLandingTermsTF.vue?vue&type=script&lang=js"
export * from "./adminLandingTermsTF.vue?vue&type=script&lang=js"
import style0 from "./adminLandingTermsTF.vue?vue&type=style&index=0&id=165857d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports